import log from 'loglevel'
import { isNil } from 'lodash/fp'
import { type fetchUtils } from 'react-admin'

import apiKeys from '../../../../cdk/bapp/lib/lambda-api/src/apiKey.json'

const env = process.env['ENV'] as string
export const url = !isNil(process.env['LOCAL'])
  ? 'http://localhost:14000/v1/entry'
  : ({
      prd: 'https://api.bapp.terashite.jp/v1/entry',
      stg: 'https://api-stg.bapp.terashite.jp/v1/entry',
      int: 'https://api-int.bapp.dev.terashite.jp/v1/entry',
      dev: 'https://api-dev.bapp.terashite.jp/v1/entry',
      exp: 'https://api-exp.bapp.dev.terashite.jp/v1/entry'
    }[env] as string)
const apiKey = apiKeys[env]

log.setLevel(log.levels.DEBUG)

export const getCustomHeaders = (
  options: fetchUtils.Options = {}
): Headers | undefined => {
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('X-API-Key', apiKey)
  return customHeaders
}
